import { FC, useMemo } from "react";
import { SearchQueryParameterController } from "@/hooks/useSearchQueryParameter";
import { ProductSearchQueryParameter } from "@/types/ProductSearchQueryParameter";
import NavigationSection from "@/components/NavigationSection";
import {
  SearchConditionGroupPullDown,
  useGetSearchConditionGroupsByCategoryId,
} from "@/features/search_product";
import { InputType } from "@/web-client";
import { SearchConditionGroupCheckbox } from "@/features/search_product/components/SearchConditionGroupCheckbox";

interface Props {
  query: ProductSearchQueryParameter;
  queryController: SearchQueryParameterController<ProductSearchQueryParameter>;
}

export const NavigationSectionSearchConditionGroups: FC<Props> = ({
  query: { category_id, search_condition_value_ids },
  queryController,
}): JSX.Element => {
  // 詳細検索項目を取得
  const { data: searchConditionGroups } =
    useGetSearchConditionGroupsByCategoryId(Number(category_id));

  // クエリから選択された詳細検索項目IDを取得
  const selectedIds = useMemo<number[]>(
    () =>
      search_condition_value_ids
        ? search_condition_value_ids?.split(",").map((v) => Number(v))
        : [],
    [search_condition_value_ids],
  );

  if (!searchConditionGroups || searchConditionGroups?.length === 0)
    return null;

  return (
    <div className="grid gap-24">
      {searchConditionGroups?.map((group) => (
        <NavigationSection
          key={group.id}
          title={group.label}
          defaultOpen={group.values.some((v) => selectedIds.includes(v.id))}
          isNew
        >
          <>
            {group.input_type === InputType.CHECKBOX && (
              <SearchConditionGroupCheckbox
                searchConditionGroup={group}
                selectedIds={selectedIds}
                queryController={queryController}
              />
            )}

            {group.input_type === InputType.SELECT && (
              <SearchConditionGroupPullDown
                searchConditionGroup={group}
                selectedIds={selectedIds}
                queryController={queryController}
              />
            )}
          </>
        </NavigationSection>
      ))}
    </div>
  );
};
